import { CandidateGoodsSearchConditionModel } from '../vo/candidate-goods-search-condition.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW1100Model } from '../kymw1100.model';

@Injectable()
export class GetCandidateGoodsListService extends PlessJsonResponderSub<any> {

  private vo: CandidateGoodsSearchConditionModel;
  private model: KYMW1100Model;

  private successFunc: Function;
  private errorFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCandidateGoodsListService
   */
  private getBody(): PlessRequest {
    let searchObj = {
      getCandidateGoodsList: {
        parameter: {
          PCode: this.vo.pcode,
          ItemCode: this.vo.itemCode,
          JANCode: this.vo.janCode,
          MakerName: this.vo.makerName,
          TagSearchType: this.vo.tagSearchType,
          GoodsMarkSearchType: this.vo.goodsMarkSearchType,
          DataKbnFlg: this.vo.dataKbnFlg,
          GoodsDiv: this.vo.goodsDiv,
          BuyerCode: this.vo.buyerCode,
          AdmitStatus: this.vo.admitStatus,
          RegistDateFrom: this.vo.registDateFrom,
          RegistDateTo: this.vo.registDateTo,
          UpdateDateFrom: this.vo.updateDateFrom,
          UpdateDateTo: this.vo.updateDateTo,
          ClassCode: this.vo.classCode,
          MiddleClassCode: this.vo.middleClassCode,
          SmallClassCode: this.vo.smallClassCode,
          OrderClientCode: this.vo.ordrClientCode,
          OrderClientKanji: this.vo.ordrClientKanji,
          PayeeClientCode: this.vo.payeeClientCode,
          PayeeClientKanji: this.vo.payeeClientKanji,
          pageNo: this.vo.pageNo,
          sortKey: this.vo.sortKey,
          orderKey: this.vo.orderKey
        }
      }
    };

    // Pコードリスト
    if (this.vo.pcodeList.length > 0) {
      searchObj["PcodeList"] = {
        combination: this.vo.pcodeList.map(pCode => ({
          parameter: {
            Pcode: pCode
          }
        }))
      };
    }

    // アイテムコードリスト
    if (this.vo.itemCodeList.length > 0) {
      searchObj["ItemCodeList"] = {
        combination: this.vo.itemCodeList.map(itemCode => ({
          parameter: {
            ItemCode: itemCode
          }
        }))
      };
    }

    // タグリスト
    if (this.vo.tagIdList.length > 0) {
      searchObj["TagIdList"] = {
        combination: this.vo.tagIdList.map(tagId => ({
          parameter: {
            TagId: tagId
          }
        }))
      };
    }

    // 商品マークコードリスト
    if (this.vo.goodsMarkCodeList.length > 0) {
      searchObj["GoodsMarkCodeList"] = {
        combination: this.vo.goodsMarkCodeList.map(goodsMarkCode => ({
          parameter: {
            GoodsMarkCode: goodsMarkCode
          }
        }))
      };
    }

    // 生協コードリスト
    if (this.vo.coopCodeList.length > 0) {
      searchObj["CoopCodeList"] = {
        combination: this.vo.coopCodeList.map(coopCode => ({
          parameter: {
            CoopCode: coopCode
          }
        }))
      };
    }

    // デイリーリスト
    if (this.vo.dutiesList.length > 0) {
      searchObj["DutiesList"] = {
        combination: this.vo.dutiesList.map(duties => ({
          parameter: {
            Duties: duties
          }
        }))
      };
    }

    // 商品案内用商品名リスト
    if (this.vo.guideGoodsNameList.length > 0) {
      searchObj["GuideGoodsNameList"] = {
        combination: this.vo.guideGoodsNameList.map(guideGoodsName => ({
          parameter: {
            GuideGoodsName: guideGoodsName
          }
        }))
      };
    }

    // 商品案内用規格名リスト
    if (this.vo.guideStandardNameList.length > 0) {
      searchObj["GuideStandardNameList"] = {
        combination: this.vo.guideStandardNameList.map(guideStandardName => ({
          parameter: {
            GuideStandardName: guideStandardName
          }
        }))
      };
    }

    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCandidateGoodsListService
   */
  execute(vo: CandidateGoodsSearchConditionModel, model: KYMW1100Model, successFunc: Function = null, errorFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.errorFunc = errorFunc;
    this.model = model;
    this.send('KYMW11getCandidateGoodsList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCandidateGoodsListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 
   * 候補リストからの検索で検索条件にヒットしない時は、一覧をクリアする。
   */
  public plessErrorHandler(errList: any): void {
    super.plessErrorHandler(errList);
    // "message": "該当するデータがありません"
    if (errList.errorcode === "E0100") {
      const emptyList = {
        CandidateGoodsList: [],
        TotalNum: 0,
        StartDispNum: 0,
        EndDispNum: 0,
      }
      this.model.updateCandidateGoodsList(emptyList);

      if (this.errorFunc != null) {
        this.errorFunc();
      }
    }
  }
}
